import { render } from "./SelfBankingView.vue?vue&type=template&id=6e300b56"
import script from "./SelfBankingView.vue?vue&type=script&lang=js"
export * from "./SelfBankingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__